export const documents = state => state.documents.documents
export const addedToWallet = state => state.documents.addedToWallet
export const loading = state => state.documents.loading
export const loaded = state => state.documents.loaded
export const timeAdded = state => state.documents.timeAdded
export const policiesDetails = state => state.documents.policiesDetails

export const hasSlipConsent = state => {
  try {
    if (state.user && state.user.user && state.user.user.hasOwnProperty('hasSlipConsent')) {
      return state.user.user.hasSlipConsent
    }
    return false
  } catch (e) {
    return false
  }
}
